// Filters the all-products table by the search box and the category chips.
import { normalize } from "../lib/search"

const input = document.querySelector<HTMLInputElement>("#q")!
const chips = [...document.querySelectorAll<HTMLButtonElement>("[data-cat]")]
const rows = [...document.querySelectorAll<HTMLTableRowElement>("tr[data-search]")]
const count = document.querySelector("#count")!
const empty = document.querySelector<HTMLElement>("#empty")!

let category = ""

const apply = () => {
  const terms = normalize(input.value).split(/\s+/).filter(Boolean)
  let shown = 0
  for (const row of rows) {
    const match =
      (!category || (row.dataset.cats ?? "").split(" ").includes(category)) &&
      terms.every((term) => (row.dataset.search ?? "").includes(term))
    row.hidden = !match
    if (match) shown++
  }
  count.textContent = String(shown)
  empty.hidden = shown > 0
  const url = new URL(location.href)
  if (input.value) url.searchParams.set("q", input.value)
  else url.searchParams.delete("q")
  history.replaceState(null, "", url)
}

for (const chip of chips)
  chip.addEventListener("click", () => {
    category = chip.dataset.cat ?? ""
    for (const other of chips) other.setAttribute("aria-pressed", String(other === chip))
    apply()
  })
input.addEventListener("input", apply)
input.value = new URLSearchParams(location.search).get("q") ?? ""
apply()
